import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import "flag-icons/css/flag-icons.min.css";

interface LanguageSwitcherProps {
  className?: string;
  variant?: "light" | "dark";
}

const LANGS = [
  { code: "fr", flag: "fr", label: "Français" },
  { code: "en", flag: "gb", label: "English" },
] as const;

const LanguageSwitcher = ({ className, variant = "light" }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "fr";

  return (
    <div className={cn("flex items-center gap-1", className)}>
      {LANGS.map((lang) => (
        <button
          key={lang.code}
          type="button"
          onClick={() => i18n.changeLanguage(lang.code)}
          aria-label={lang.label}
          title={lang.label}
          className={cn(
            "rounded-sm p-1 transition-opacity",
            current === lang.code
              ? "opacity-100 ring-1 ring-nautic-gold"
              : "opacity-50 hover:opacity-90",
            variant === "dark" && "ring-offset-1"
          )}
        >
          <span className={`fi fi-${lang.flag} block h-4 w-6 rounded-[2px]`} />
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
